<!-- START : Page  -->
<div class="box">
    <div class="box-header pb-3 pt-3">
        <h4 class="box-title">
            <span class="">RPP List</span>
        </h4>
    </div>
    <!-- User statistics   -->
    <div class="box-body">

        <div class="row">
            <div class="box-body">
                <div class="d-flex justify-content-between align-items-end mb-2">
                    <div class="col-lg-4 col-md-4 col-sm-12">
                        <button pButton pRipple type="button" label="Export CSV" (click)="exportCSV()"
                            class="p-button-sm p-button-outlined" title="Export to CSV"></button>
                    </div>
                    <div class="d-flex justify-content-end gap-2 align-items-end select-patient-status">
                        <div class="d-flex flex-column">
                            <div class="d-flex gap-2">
                                <button pButton class="p-button-success" [class.p-button-active]="isPatientStatusActive === 'Active'" type="button" label="Active" (click)="getPatientGridData('Active')"></button>
                                <button pButton class="p-button-success" [class.p-button-active]="isPatientStatusActive === 'Inactive'" type="button" label="Inactive" (click)="getPatientGridData('Inactive')"></button>
                            </div>
                        </div>
                        <div class="input-group search-mob pull-right">

                            <!-- -->
                            <input type="text" class="form-control" name="contact" maxlength="12"
                                (keydown.enter)="searchWithPhoneNumber()" [(ngModel)]="contactNumber"
                                placeholder="Name/Mobile No.">
                            <div class="input-group-append">
                                <button [ngClass]="{'btn-dark' : disableSearch, 'btn-primary': !disableSearch}"
                                    class="btn btn-sm" type="button" (click)="searchWithPhoneNumber()"><i
                                        class="pi pi-search"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
                <!--  -->
                <div class="row">
                    <div class="col">
                        <div class="row no-gutters grid-table-height">
                            <div class="col">
                                <!---->
                                <app-commongrid #dataGrid gridId='commonGrid' sField='updatedDate' [colModel]='cols'
                                    sOrder='desc' [localData]="[]" idColumn='userGrid' [rowsPerPage]='50'
                                    paginationpos='bottom' (onCustomrowSelect)="onCustomrowSelect($event)"
                                    (onCustomFilterEvent)="onCustomFilter($event)"
                                    (onCustomPageAndFilterEvent)="onPageChangeEvent($event)">

                                    <ng-template #patientTimeline let-gridData='griddata'>
                                        <button pButton icon="pi pi-eye" class="patient-timeline-button" (click)="handleGetPatientTimeline(gridData.patient_id, $event)"></button>
                                    </ng-template>

                                    <ng-template #packageDetails let-gridData='griddata'>
                                        <button pButton class="patient-package-fetch-button" (click)="handleGetPatientPackageDetails(gridData.patient_id, $event)">Get</button>
                                    </ng-template>

                                    <ng-template #patientStatus let-gridData='griddata'>
                                        <span class="badge badge-{{gridData.patient_status == 'Active' ? 'success' : 'danger'}}">{{ gridData.patient_status }}</span>
                                    </ng-template>

                                    <ng-template #csrTemp let-gridData='griddata'>
                                        <span>{{ handleGetCsr(gridData) }}</span>
                                    </ng-template>

                                    <ng-template #nvfStatus let-gridData='griddata'>
                                        <span>{{ gridData.is_nvf_facility ? 'Yes': 'No' }}</span>
                                    </ng-template>

                                    <ng-template #consentFormFilledTemp let-gridData='griddata'>
                                        <span>{{ gridData.isConsentFormFilled ? 'Yes': 'No' }}</span>
                                    </ng-template>

                                    <ng-template #wearableStatusTemp let-gridData='griddata'>
                                        <span>{{ gridData.wearable_status ? 'Yes': 'No' }}</span>
                                    </ng-template>

                                    <ng-template #assesmentStatusTemp let-gridData='griddata'>
                                        <span>{{ gridData.assesment_status ? 'Yes': 'No' }}</span>
                                    </ng-template>

                                    <ng-template #inductionDoneTemp let-gridData='griddata'>
                                        <span class="badge badge-success" *ngIf="gridData.induction_done">DONE</span>
                                        <i class="pi pi-pencil cursor-pointer pencil-color" *ngIf="!gridData.induction_done" (click)="handleGetInductionDetails(gridData, $event)"></i>
                                    </ng-template>

                                    <ng-template #actionTemplate let-gridData='griddata'>
                                        <!-- *ngIf="dataService.addeditPermission('Patient List') && (gridData.status == 'Paid'||gridData.status == 'Patient Details Completed'||gridData.status == 'Assessments & Summary Completed'||gridData.status == 'Form 5 Completed'||gridData.status == 'Diagnosis Completed' || gridData.status == 'Treatment Form Completed'|| gridData.status == 'Session Completed')" -->

                                        <button *ngIf="dataService.addeditPermission('RPP Patient Assignment') && (gridData.status == 'Paid') || 
                                 (gridData.status == 'Pay Later') ||
                                 (gridData.status == 'Assigned') || (gridData.status == 'Expired')"
                                            (click)="editPatient(gridData)" class="butonclover" title="Edit">
                                            <span class="actionicons iconscls text-warning"><i
                                                    class="ti ti-pencil"></i></span>
                                        </button>


                                    </ng-template>
                                    <ng-template #statuTemplate let-gridData='griddata'>

                                        <ng-container *ngIf="gridData.status == 'Active'
                                        ">
                                            <span class="badge badge-success me-3">Active</span>
                                            <a *ngIf="showExpiredbutton" href="#" class="" data-toggle="tooltip"
                                                (click)="redirectregisterpage(gridData)" data-placement="top"
                                                title="Renew"><i class="pi pi-refresh"></i></a>
                                        </ng-container>
                                        <ng-container *ngIf="gridData.status == 'Package Expired'
                                        ">
                                            <span class="badge badge-danger">Package Expired</span>
                                            <a *ngIf="showExpiredbutton" href="#" class="" data-toggle="tooltip"
                                                (click)="redirectregisterpage(gridData)" data-placement="top"
                                                title="Renew"><i class="pi pi-refresh"></i></a>
                                        </ng-container>

                                    </ng-template>
                                    <ng-template #payTemplate let-gridData='griddata'>
                                        <ng-container *ngIf="gridData.payment_type_name == 'Pay Later'">
                                            <span class="badge badge-danger">Pay Later</span>
                                            <a href="#" class="me-3" data-toggle="tooltip"
                                                (click)="redirectregisterpage(gridData)" data-placement="top"
                                                title="Update Payment"><img
                                                    src="assets/images/hospital-icon/paylater.svg" height="34px"></a>
                                        </ng-container>
                                        <ng-container *ngIf="gridData.payment_type_name == 'Cash'">
                                            <span class="badge badge-success">Cash</span>

                                        </ng-container>
                                        <ng-container *ngIf="gridData.payment_type_name == 'Online'">
                                            <span class="badge badge-success">Online</span>
                                        </ng-container>
                                    </ng-template>
                                </app-commongrid>
                                <!--  -->

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- END : Page  -->


<p-dialog header="Patient Session Details" [modal]="true" [(visible)]="isModalOpen" [style]="{ width: '40rem' }">
    <app-package-details [patientPackageDetails]="patientPackageDetails"></app-package-details>
</p-dialog>

<p-dialog header="Induction Details" [modal]="true" [(visible)]="isInductionModalOpen" [style]="{ width: '45rem' }">
    <app-induction-detail-form [patientInductionDetails]="patientInductionDetails"
                               [selectedPatient]="selectedPatient"
                               (onInductionDoneChange)="onInductionDoneChange($event)"
                               >
    </app-induction-detail-form>
</p-dialog>